import { AsyncLocalStorage } from 'async_hooks';

// The axios client is a module singleton shared by every request a warm
// function instance serves. Anything per-user (token, refresh handler) lives
// here instead of on the client's defaults, so it cannot leak between requests.
const storage = typeof window === 'undefined' ? new AsyncLocalStorage() : null;

export const runWithRequestScope = (fn) =>
    storage ? storage.run({}, fn) : fn();

export const requestScope = () => storage?.getStore();

// In the browser there is one session, so one slot; on the server it hangs off
// the request.
let clientSlot = null;
const readSlot = (scope) => (scope ? scope.refreshInflight : clientSlot);
const writeSlot = (scope, value) => {
    if (scope) scope.refreshInflight = value;
    else clientSlot = value;
};

// The backend keeps a single refresh token per user and rotates it on every
// use, answering 400 to whoever replays the old one - and that loser clears the
// session. So concurrent expiries have to share one refresh instead of each
// starting their own.
export const sharedRefresh = (run) => {
    const scope = storage?.getStore();
    // Outside a request scope on the server there is nowhere safe to park the
    // promise: sharing it across requests would hand one user another's token.
    if (storage && !scope) return Promise.resolve().then(run);

    const existing = readSlot(scope);
    if (existing) return existing;

    const pending = Promise.resolve()
        .then(run)
        .finally(() => writeSlot(scope, null));
    writeSlot(scope, pending);
    return pending;
};
